<div id="error-404" fxLayout="column" fxLayoutAlign="center center">
  <div class="content" fxLayout="column" fxLayoutAlign="center center">
    <div class="error-code">Domain is Not Registered</div>
  </div>
</div>
